<template lang="pug">
.BaseMoreButton(@click="pushPath")
  .text 更多
  i.el-icon-caret-bottom
</template>

<script>
export default {
  props: {
    path: String
  },
  data () {
    return {
    }
  },
  methods: {
    pushPath () {
      this.$router.push(this.path)
    }
  }
}
</script>

<style lang="scss" scoped>
.BaseMoreButton {
  color: #347eee;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  white-space: nowrap;
  cursor: pointer;
  & > i {
    margin-left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/HomePage/components/BaseMoreButton.vue